import { render, staticRenderFns } from "./DetailAttributes.vue?vue&type=template&id=3ea7bab1&scoped=true&"
import script from "./DetailAttributes.vue?vue&type=script&lang=js&"
export * from "./DetailAttributes.vue?vue&type=script&lang=js&"
import style0 from "./DetailAttributes.vue?vue&type=style&index=0&id=3ea7bab1&prod&lang=scss&"
import style1 from "./DetailAttributes.vue?vue&type=style&index=1&id=3ea7bab1&prod&lang=scss&scoped=true&"
import style2 from "./DetailAttributes.vue?vue&type=style&index=2&id=3ea7bab1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea7bab1",
  null
  
)

export default component.exports